import { Flex, Space, Typography } from "antd"
import { IProjectData } from "../types/projectData.types"
import NotAvailableTag from "../../../ui/NotAvailableTag"
import { AmazonDataState } from "../../../types/project"

const { Text } = Typography

interface IProductProps {
  asin: IProjectData
}

const Product: React.FC<IProductProps> = ({ asin }) => {
  return (
    <Space>
      <img src={asin.imageUrl} style={{ width: 60 }} />
      <Flex vertical>
        <span>
          {asin.asin}
          {asin.isPrimary ? <Text strong>(Primary)</Text> : null}
        </span>
        <span>{asin.title}</span>
      </Flex>
      {asin.state && asin.state !== AmazonDataState.AVAILABLE && (
        <NotAvailableTag
          amazonDataState={asin.state}
          tooltipText={
            asin.state === AmazonDataState.NOT_IN_AMAZON
              ? "No results found for this ASIN on Amazon"
              : "Data is being fetched from Amazon. This will take 10–30 minutes"
          }
        />
      )}
    </Space>
  )
}

export default Product
